export const API_BASE_URL = 'https://social-auto-r8we.onrender.com';
